import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'recent-uploads',
  templateUrl: './recent-uploads.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryRecentUploadsComponent implements OnInit {
  @Input() data;
  @Output() moveNextPreviousEvent = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  handleSteps(event) {
    this.moveNextPreviousEvent.emit({ status: event, ...(event == 'forward' && { id: this.data?.id }) });
  }
}
